import React, { useEffect, useRef } from "react";
import { InlineCheck, RadioField, Field } from "./fields";
import { NO_FUNDING, NoFundingOptions, CloseButton, NoticePanel } from "./NoFundingNotice";
import { NavButtons } from "./NavButtons";
import { FUNDING_OPTIONS } from "../../lib/options";
import { INTAKE } from "../../constants/testIds";

export const Stage2Funding = ({ form, set, onBack, onContinue }) => {
  const checked = !!form.funding_ack;
  const budget = form.budget;
  const noFunding = budget === NO_FUNDING;
  const noticeRef = useRef(null);
  const nfChoice = form.no_funding_choice;

  useEffect(() => {
    if (noFunding && noticeRef.current && typeof window !== "undefined") {
      const el = noticeRef.current;
      const top = el.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    }
  }, [noFunding]);

  return (
    <div className="space-y-6">
      <h2 className="font-serif text-3xl text-brand-black">Private Funding Notice</h2>
      <div ref={noticeRef}>
        <NoticePanel noFunding={noFunding} testid="funding-notice" />
      </div>
      {noFunding && (
        <NoFundingOptions value={nfChoice} onChange={(v) => set("no_funding_choice", v)} prefix="funding" />
      )}
      <div className="border border-border bg-white p-4">
        <InlineCheck
          checked={checked}
          onChange={(v) => set("funding_ack", !!v)}
          label="I understand that this is a privately funded service."
          testid={INTAKE.fundingCheckbox}
        />
      </div>
      {checked && (
        <Field label="What budget do you presently have available?" required>
          <RadioField
            options={FUNDING_OPTIONS}
            value={budget}
            onChange={(v) => set("budget", v)}
            name="funding-budget"
            testid="funding-budget"
          />
        </Field>
      )}
      <NavButtons onBack={onBack} onNext={onContinue} disabled={!checked || !budget || (noFunding && nfChoice !== "secure")}
        rightSlot={noFunding && nfChoice === "none" ? <CloseButton testid="funding-close" source="funding" /> : null}
      />
    </div>
  );
};
